// Qué secciones del menú se pintan.
//
// Una sección sin ninguna entrada visible NO se pinta: ni su rótulo ni su
// separador. Antes cada rótulo iba suelto en el JSX y sólo las entradas
// miraban el permiso, así que alguien de logística veía «OPERACIONES» y
// «COMPRAS / VENTAS» sin nada debajo — un menú que parece roto.
//
// La regla vive aquí, en una función pura, y no repetida en cada bloque del
// sidebar: la siguiente sección nueva entra declarando sus entradas, sin tener
// que acordarse de envolver el rótulo en la misma condición que sus enlaces.

export interface NavEntrada<T> {
  visible: boolean
  entrada: T
}

export interface NavSeccion<T> {
  clave: string
  entradas: NavEntrada<T>[]
}

/** Las secciones con al menos una entrada visible, y en ellas sólo las visibles. */
export function seccionesVisibles<T>(secciones: NavSeccion<T>[]): { clave: string; entradas: T[] }[] {
  return secciones
    .map(s => ({ clave: s.clave, entradas: s.entradas.filter(e => e.visible).map(e => e.entrada) }))
    .filter(s => s.entradas.length > 0)
}
